<template>
  <div>
    <card class="table-container">
      <span slot="header">
        <slot name="headerData"></slot>
      </span>

      <OverlayProgress :active="loading || extLoading" />

      <div class="dash-table__container">
        <paper-table :data="tableData" :columns="columns" class="dash-table">
          <template slot="columns">
            <slot name="thead"></slot>
          </template>
          <template
            v-for="slot in Object.keys($scopedSlots)"
            :slot="slot"
            slot-scope="scope"
          >
            <slot :name="slot" v-bind="scope" />
          </template>
        </paper-table>
        <v-pagination
          v-model="currentPage"
          :page-count="pagesCount"
          :classes="paginationClasses"
          v-if="pagesCount > 1"
        ></v-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import axios from "../axios";
import { apiError } from "@/util/ErrorMessage.js";
import { PaperTable } from "@/components";
import vPagination from "vue-plain-pagination";
import OverlayProgress from "./OverlayProgress";

export default {
  name: "DatapointsTable",
  props: {
    title: {
      type: String,
      default: "No title"
    },
    tableData: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    pagesCount: {
      type: Number,
      default: 0
    },
    paginationMethod: {
      type: String
    },
    extLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PaperTable,
    vPagination,
    OverlayProgress
  },
  data() {
    return {
      color: "#000000",
      currentPage: 1,
      paginationClasses: {
        ul: "pagination",
        li: "pagination__item",
        liActive: "active",
        liDisable: "disabled",
        button: "pagination__item"
      },
      loading: false
    };
  },
  watch: {
    currentPage: async function() {
      this.loading = true;

      try {
        if (this.paginationMethod === "fetchDatapoints") {
          await this.$store.dispatch(this.paginationMethod, {
            page: this.currentPage,
            filter: ""
          });
        } else {
          await this.$store.dispatch(this.paginationMethod, this.currentPage);
        }
      } catch (error) {
        apiError(error, this);
      }

      this.loading = false;
    }
  }
};
</script>
<style lang="scss">
.table {
  &__flex-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    font-size: 1.5em;
    line-height: 1.2em;
  }

  &__relative-container {
    position: relative;
  }

  &__filter {
    width: 180px;
    border: black 1px solid;
    border-radius: 5px;
    margin-left: 10px;
    margin-bottom: 0px !important;
  }
}

.dash-table {
  &__container {
    margin-top: 10px;
  }
}

.pagination {
  display: flex;
  list-style: none;
  border-radius: 0.25rem;
  justify-content: center;

  &__item {
    border: none;
    background-color: transparent;
    font-size: 20px;
  }
}
</style>
